// App.js
import React, { useState, useContext, createContext, useEffect } from 'react';
import Select from 'react-select';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation, useNavigate, Link } from 'react-router-dom';
import './App.css';
import sketch from './sketch';
import sketch2 from './sketch2';
import sketch3 from './sketch3';

// --- Background Canvas ---
function BackgroundCanvas() {
  const canvasRef = React.useRef();

  React.useEffect(() => {
    let p5Instance;
    let script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/p5@1.11.8/lib/p5.min.js';
    script.async = true;

    function startSketch() {
      if (!window.p5) return;

      // Randomly select between sketch, sketch2, and sketch3
      const sketches = [sketch,
        sketch2, 
        // sketch3
      ];
      const randomSketch = sketches[Math.floor(Math.random() * sketches.length)];
      p5Instance = new window.p5(sketch, canvasRef.current);
    }

    script.onload = startSketch;
    document.body.appendChild(script);

    return () => {
      if (p5Instance) p5Instance.remove();
      document.body.removeChild(script);
    };
  }, []);

  // Style: absolute, behind everything, full viewport
  return (
    <div
      ref={canvasRef}
      style={{
        position: 'fixed',
        zIndex: -2,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        overflow: 'hidden',
        background: "url('https://storage.googleapis.com/heldsolutionsllc-public-bucket/backgrounds/geometric.png') no-repeat center center fixed",
        backgroundSize: 'cover',
      }}
      aria-hidden="true"
    />
  );
}


export default BackgroundCanvas;